import { OEM } from "@app/enums/OEM";
import { ReactComponent as AllgoLogoIconSVG } from "@app/assets/all_go_logo_small.svg";
import { ReactComponent as SkodaLogoIconSVG } from "@app/assets/icons/skoda/icon.svg";
import { ReactComponent as MsilLogoIconSVG } from "@app/assets/icons/msil/icon.svg";
import { ReactComponent as VWLogoIconSVG } from "@app/assets/icons/vw/icon.svg";
import { FC, SVGProps } from "react";
import { FontFamily } from "@app/enums/FontFamily";
import { Color } from "@app/types/Color";
import { MsilColors } from "@app/themes/colors/MsilColors";
import { SkodaColors } from "@app/themes/colors/SkodaColors";

type OEMConfig = {
    logo: FC<SVGProps<SVGSVGElement>>;
    fontFamily: FontFamily;
    color: Color;
};

/**
 * Get the OEM configuration based on the brand
 * @param brand - The brand to get the configuration for
 * @returns The OEM configuration
 */
export const getOEMConfig = (brand?: string): OEMConfig => {
    const oem = (process.env.OEM as OEM) || "";

    switch (oem) {
        case OEM.MSIL:
            return {
                logo: MsilLogoIconSVG,
                fontFamily: FontFamily.Roboto,
                color: MsilColors,
            };
        case OEM.SKODA:
            return {
                logo: brand?.toLowerCase() === OEM.VW ? VWLogoIconSVG : SkodaLogoIconSVG,
                fontFamily: FontFamily.VWTextCarUI,
                color: SkodaColors,
            };
        default:
            return {
                logo: AllgoLogoIconSVG,
                fontFamily: FontFamily.Roboto,
                color: MsilColors,
            };
    }
};
